import { ensureDate, formatDate } from '@helpers/date';
import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { formatCurrency } from '@helpers/utils';
import { withMotion } from '@hoc/withMotion';
import { withRedux } from '@hoc/withRedux';
import SvgCalendar from '@img/icons/calendar.svg';
import SvgDelete from '@img/icons/delete.svg';
import { basket } from '@redux/slices/basket';
import { deleteProduct } from '@redux/slices/basket/actions/deleteProduct';
import { updateBasketProduct } from '@redux/slices/basket/actions/updateBasketProduct';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { isFulfilled } from '@reduxjs/toolkit';
import Button from '@stories/Components/Global/Buttons/Button/Button';
import Datepicker from '@stories/Components/Global/DatePicker/DatePicker';
import ErrorSummary from '@stories/Components/Global/Forms/ErrorSummary';
import FormField from '@stories/Components/Global/Forms/FormField';
import FormRow from '@stories/Components/Global/Forms/FormRow';
import Textbox from '@stories/Components/Global/Inputs/Textbox/Textbox';
import LoadingIndicator from '@stories/Components/Global/LoadingIndicator/LoadingIndicator';
import Modal from '@stories/Components/Global/Modal/Modal';
import QuantitySelector from '@stories/Components/Global/QuantitySelector/QuantitySelector';
import { addBusinessDays, isBefore, startOfToday } from 'date-fns';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { toast } from 'react-toastify';
import S from './CartProductCard.styles';
const CartProductCard = (props) => {
    const srcs = getSrcs(props.image, 285, 80, 4, props.site);
    const sizes = props.variant === 'full'
        ? `${until(Device.TabletLarge)} 30vw, ${until(Device.Desktop)} 18.75vw, ${until(Device.ActualDesktop)} 14vw, 240px`
        : `${until(Device.Tablet)} 30vw, ${until(Device.DesktopSmall)} 168px, ${until(Device.ActualDesktop)} 8vw, 70px`;
    const dispatch = useAppDispatch();
    const { status: basketStatus, productId } = useAppSelector((state) => state.basket);
    const [accordionOpen, setAccordionOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    /** Used to define when product has been deleted from basket */
    const [status, setStatus] = React.useState('initial');
    const [qty, setQty] = React.useState(props.qty);
    const [lineTotal, setLineTotal] = React.useState(props.lineTotal);
    const [onDateInitial, setOnDateInitial] = React.useState(props.onDate &&
        !isBefore(ensureDate(props.onDate), addBusinessDays(startOfToday(), props.calendarLeadTime ?? 5))
        ? props.onDate
        : addBusinessDays(new Date(), props.calendarLeadTime ?? 5));
    const [offDateInitial, setOffDateInitial] = React.useState(props.offDate &&
        !isBefore(ensureDate(props.offDate), addBusinessDays(startOfToday(), props.calendarLeadTime ?? 5))
        ? props.offDate
        : addBusinessDays(new Date(), 5 + (props.calendarLeadTime ?? 5)));
    const [onDate, setOnDate] = React.useState(props.onDate &&
        !isBefore(ensureDate(props.onDate), addBusinessDays(startOfToday(), props.calendarLeadTime ?? 5))
        ? props.onDate
        : addBusinessDays(new Date(), props.calendarLeadTime ?? 5));
    const [offDate, setOffDate] = React.useState(props.offDate &&
        !isBefore(ensureDate(props.offDate), addBusinessDays(startOfToday(), props.calendarLeadTime ?? 5))
        ? props.offDate
        : addBusinessDays(new Date(), 5 + (props.calendarLeadTime ?? 5)));
    return (React.createElement(S.Wrapper, { "data-site": props.site },
        props.errors && props.errors.length > 0 ? (React.createElement(ErrorSummary, { errors: props.errors, site: props.site ?? 'ess' })) : null,
        React.createElement(S.Container, { "data-site": props.site, "data-variant": props.variant },
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText ?? props.name })),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.TopWrapper, null,
                    props.variant === 'full' && (React.createElement(S.ImageWrapper, null,
                        React.createElement(S.Image, { src: srcs[0].split(' ')[0], srcSet: srcs.join(','), sizes: sizes, alt: props.image.altText ?? props.name }))),
                    React.createElement(S.TitlePriceWrapper, null,
                        React.createElement("div", null,
                            React.createElement(S.Title, null, props.name),
                            React.createElement(S.Id, null, props.g42Id)),
                        props.showPrice && (React.createElement(S.PriceWrapper, null,
                            React.createElement(S.Price, null, props.price.isValid ?? true
                                ? formatCurrency(props.price.incl)
                                : 'Invalid price'),
                            ' ',
                            React.createElement(S.Suffix, null, props.price.suffix))))),
                props.included && props.included.length > 0 && (React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
                    React.createElement(S.AccordionWrapper, null,
                        React.createElement(Button, { buttonType: "link-alt", "data-active": accordionOpen, onClick: () => setAccordionOpen(!accordionOpen), site: props.site }, "What's Included"),
                        React.createElement(S.AccordionArea, { initial: accordionOpen ? 'opened' : 'closed', animate: accordionOpen ? 'opened' : 'closed', variants: {
                                closed: {
                                    height: 0,
                                    transitionEnd: {
                                        visibility: 'hidden',
                                    },
                                },
                                opened: {
                                    visibility: 'visible',
                                    height: 'auto',
                                },
                            } },
                            React.createElement(S.Content, null,
                                React.createElement("ul", null, props.included.map((incl, i) => (React.createElement("li", { key: `${props.id}-included-${i}` }, incl))))))))),
                React.createElement(S.BottomWrapper, { "data-has-datepicker": props.variant === 'full' && onDateInitial !== '' },
                    props.variant === 'full' && props.showPrice && (React.createElement(S.TotalPrice, null,
                        "Total ",
                        props.type === 'hire' && 'Hire',
                        " Cost:",
                        ' ',
                        props.price.isValid ?? true ? formatCurrency(lineTotal) : 'Invalid price')),
                    props.variant === 'full' && props.type === 'hire' && (React.createElement(FormRow, null,
                        React.createElement(FormField, { name: "onDate", label: "On Hire Date" },
                            React.createElement(Textbox, { placeholder: "DD/MM/YYYY", type: "text", value: onDateInitial ? formatDate(onDateInitial, 'dd/MM/yyyy') : undefined, readOnly: true, onClick: () => setOpen(true) }),
                            React.createElement(S.CalendarIcon, null,
                                React.createElement(SvgCalendar, null))),
                        React.createElement(FormField, { name: "offDate", label: "Off Hire Date" },
                            React.createElement(Textbox, { placeholder: "DD/MM/YYYY", type: "text", value: offDateInitial ? formatDate(offDateInitial, 'dd/MM/yyyy') : undefined, readOnly: true, onClick: () => setOpen(true) }),
                            React.createElement(S.CalendarIcon, null,
                                React.createElement(SvgCalendar, null))))),
                    React.createElement(S.QuantityPriceWrapper, null,
                        React.createElement(QuantitySelector, { value: qty, onDownPress: () => updateProduct(qty - 1), onUpPress: () => updateProduct(qty + 1), site: props.site, disabled: false }),
                        props.variant === 'full' ? (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.DeleteButton, { "aria-label": `Remove ${props.name} from basket`, onClick: deleteProductFromBasket },
                                React.createElement(SvgDelete, null)))) : (React.createElement(React.Fragment, null, props.showPrice && (React.createElement(S.PriceWrapper, null,
                            React.createElement(S.Price, null, props.price.isValid ?? true
                                ? formatCurrency(props.price.incl)
                                : 'Invalid price'),
                            ' ',
                            React.createElement(S.Suffix, null, props.price.suffix)))))))),
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.DeleteButton, { "aria-label": `Remove ${props.name} from basket`, onClick: deleteProductFromBasket },
                    React.createElement(SvgDelete, null))),
            (basketStatus === 'pending' || basketStatus === 'submitting') && productId === props.id ? (React.createElement(LoadingIndicator, { label: "Loading\u2026", layout: "absolute" })) : null,
            status === 'complete' && (React.createElement(S.RemovedOverlay, null,
                React.createElement(S.RemovedOverlayText, null, "Product removed from basket.")))),
        React.createElement(Modal, { site: props.site, showClose: false, ariaLabel: `Change hire dates for ${props.name} Modal`, isOpen: open, showBackground: true, onClose: () => {
                setOnDate(onDateInitial);
                setOffDate(offDateInitial);
                setOpen(false);
            }, closeOnBackground: true },
            React.createElement(S.AddToBasketModal, null,
                React.createElement(S.AddToBasketModalContent, null,
                    React.createElement(Datepicker, { label: "Change Hire Dates", onStartDateChanged: setOnDate, onEndDateChanged: setOffDate, endDate: ensureDate(offDate), startDate: ensureDate(onDate), excludedDates: props.excludedDates, leadTimeDays: props.calendarLeadTime }),
                    React.createElement(S.ModalButtonWrapper, null,
                        React.createElement(Button, { buttonType: props.site === 'mep' ? 'default' : 'secondary', site: props.site, disabled: status === 'loading', onClick: () => {
                                updateProduct(qty);
                                setOpen(false);
                            } }, "Update Hire Dates")))))));
    async function updateProduct(amount) {
        dispatch(basket.actions.setStatus('pending'));
        dispatch(basket.actions.setProductId(props.id));
        const result = await dispatch(updateBasketProduct({
            id: props.id,
            qty: amount,
            onDate: onDate,
            offDate: offDate,
            currentPageProductId: props.currentProductPageId,
        }));
        /**
         * Update quantity shown or display error message.
         */
        if (isFulfilled(result) && result.payload) {
            if (result.payload.errors) {
                toast(result.payload.errors.join(' '), { type: 'error' });
            }
            else {
                const item = result.payload.items.find((item) => item.id === props.id);
                if (item) {
                    setQty(item.qty);
                    setLineTotal(item.lineTotal);
                    item.onDate && setOnDateInitial(item.onDate);
                    item.offDate && setOffDateInitial(item.offDate);
                }
            }
        }
        else {
            setOnDate(onDateInitial);
            setOffDate(offDateInitial);
            toast(`Error changing item quantity, please try again`, { type: 'error' });
        }
    }
    async function deleteProductFromBasket() {
        dispatch(basket.actions.setStatus('pending'));
        dispatch(basket.actions.setProductId(props.id));
        const result = await dispatch(deleteProduct({ id: props.id, currentPageProductId: props.currentProductPageId }));
        /**
         * Set status as complete (product deleted) or show error message.
         */
        if (isFulfilled(result) && result.payload) {
            if (result.payload.errors) {
                toast(result.payload.errors.join(' '), { type: 'error' });
            }
            else {
                setStatus('complete');
            }
        }
        else {
            setStatus('initial');
            toast(`Error removing item from basket, please try again`, { type: 'error' });
        }
    }
};
export default withRedux(withMotion(CartProductCard));
